import React from "react"
import PropTypes from "prop-types"

import { MoreInfoNeededForm } from "./Form"
import { MoreInfoNeededConfirmation } from "./Confirmation"

export const MoreInfoNeeded = ({ quoteId, location }) => {
  const [callbackInfo, setCallbackInfo] = React.useState()

  return callbackInfo ? (
    <MoreInfoNeededConfirmation
      callbackInfo={callbackInfo}
      location={location}
    />
  ) : (
    <MoreInfoNeededForm
      quoteId={quoteId}
      setCallbackInfo={setCallbackInfo}
      location={location}
    />
  )
}

MoreInfoNeeded.propTypes = {
  quoteId: PropTypes.string.isRequired,
}
